import { IRootState } from 'app/shared/reducers';
import { countriesList } from 'app/shared/util/method-util';
import { createSelector } from 'reselect';
import { ConfigState } from './config.state';

const selectConfigState: any = (state: IRootState) => state.config;

export const getFilteredCountries = createSelector<IRootState, ConfigState, any>(selectConfigState, (config: ConfigState) => {
  if (config.countries && config.countries.length !== 0) {
    return countriesList.filter(el => config.countries.includes(el.value));
  } else return countriesList;
});

export const loadTotalProgressSteps = createSelector<IRootState, ConfigState, any>(
  selectConfigState,
  (config: ConfigState) => config?.steps?.part?.length
);

export const getWebsiteTitle = createSelector<IRootState, ConfigState, any>(selectConfigState, (config: ConfigState) => config.title || '');
